const setCSSVariables = (variables) => {
  const styleTag = document.createElement("style");
  styleTag.setAttribute("type", "text/css");
  styleTag.setAttribute("id", "x-theme-colors");
  styleTag.innerHTML = variables;
  document.querySelector("head").appendChild(styleTag);
};

export default setCSSVariables;
